function ResetPassword() {
  return <></>;
}

export default ResetPassword;
